import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import type { BasicCustomMailSettingI18nQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { basicCustomMailSettingI18nSchema, type BasicCustomMailSettingFormData } from "../../schema/validation-schema";

import type { UseFormReturn } from "react-hook-form";

type Props = {
	hotelID: string;
	customMailSetting?: BasicCustomMailSettingI18nQuery["basicCustomMailSettingI18n"];
	langCode: LangCode;
};

export const useCustomMailSettingForm = ({
	hotelID,
	customMailSetting,
	langCode,
}: Props): { form: UseFormReturn<BasicCustomMailSettingFormData> } => {
	const defaultValues: BasicCustomMailSettingFormData = {
		id: hotelID,
		lang: langCode,
		// mailFooterExternalLink: customMailSetting?.mailFooterExternalLink ?? "",
		forReservation: {
			atCreated: {
				text: customMailSetting?.forReservation?.atCreated?.text ?? "",
			},
			atUpdated: {
				text: customMailSetting?.forReservation?.atUpdated?.text ?? "",
			},
			atCanceled: {
				text: customMailSetting?.forReservation?.atCanceled?.text ?? "",
			},
			atCheckInBefore_07days: {
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_07days?.shouldSendEmail ?? false,
				text: customMailSetting?.forReservation?.atCheckInBefore_07days?.text ?? "",
			},
			atCheckInBefore_01days: {
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_01days?.shouldSendEmail ?? false,
				text: customMailSetting?.forReservation?.atCheckInBefore_01days?.text ?? "",
			},
			atCheckInBefore_00days: {
				shouldSendEmail: customMailSetting?.forReservation?.atCheckInBefore_00days?.shouldSendEmail ?? true,
				text: customMailSetting?.forReservation?.atCheckInBefore_00days?.text ?? "",
			},
			atCheckOutAfter_01days: {
				shouldSendEmail: customMailSetting?.forReservation?.atCheckOutAfter_01days?.shouldSendEmail ?? false,
				text: customMailSetting?.forReservation?.atCheckOutAfter_01days?.text ?? "",
			},
			atRequest: {
				text: customMailSetting?.forReservation?.atRequest?.text ?? "",
			},
			atConfirmed: {
				text: customMailSetting?.forReservation?.atConfirmed?.text ?? "",
			},
			atDeclined: {
				text: customMailSetting?.forReservation?.atDeclined?.text ?? "",
			},
		},
		forShopping: {
			atCreated: {
				text: customMailSetting?.forShopping?.atCreated?.text ?? "",
			},
		},
	} satisfies BasicCustomMailSettingFormData;

	const form: UseFormReturn<BasicCustomMailSettingFormData> = useForm<BasicCustomMailSettingFormData>({
		mode: "onChange",
		resolver: zodResolver(basicCustomMailSettingI18nSchema),
		defaultValues,
	});

	const { trigger } = form;

	// 初回バリデーション実行
	useEffect(() => {
		trigger();
	}, [trigger]);

	return { form };
};
